var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal modal-change-order-detail",
      attrs: {
        name: "ModalChangeOrder",
        width: 1300,
        height: 670,
        scrollable: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", { staticClass: "modal-header-change-order-text" }, [
          _vm._v(_vm._s(_vm.modalData.title))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body-changeOrderDetail" },
        [
          _c("div", { staticClass: "modal-header-line" }),
          _vm._v(" "),
          _c("a", [
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "modal-body-changeOrderDetail-text" }, [
              _vm._v(
                "Requesting changes will charge you based on contract rates. Cancelling will not."
              )
            ])
          ]),
          _c("br"),
          _vm._v(" "),
          _c("DataTable", {
            staticClass: "modal-body-changeOrderDetail-event-detail",
            attrs: {
              editable: true,
              showOnModal: true,
              parentEvent: [_vm.actionData]
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79eb3b64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79eb3b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalChangeOrderDetail.vue
// module id = 1526
// module chunks = 1